import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DettaglioDateDataSource } from 'src/app/services/dettaglio-date.datasource';
import { EventiSegnalazioniDataSource } from 'src/app/services/eventi-segnalazioni.datasource';
import { TemplateService } from 'src/app/services/template.service';
import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { tap } from 'rxjs/operators';
import { merge } from 'rxjs';
import { AclTipo } from 'src/app/model/AclTipo.enum';
import { EventiService } from 'src/app/services/eventi.service';
import { environment } from 'src/environments/environment';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css']
})
export class UploadFileComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('numProtoInput') numProtoInput: NgModel;
  fileName = '';
  fileSize = '';
  fileType = '';
  uploadProgress = 0;
  isUploading = false;
  nomeEvento: string = "";
  idEvento: number = 0;
  idEnte: number = 0;
  idInvio: number = 0;
  numProtoEnteAt: string | null = null;
  dataProtoEnteAt: Date | null = null;
  isNumProtoInvalid: boolean = false;

  acl: String;
  isError: Boolean;
  uploadCompletedWithoutErrors: Boolean = false;
  fileUploaded: File;

  constructor(public dialogRef: MatDialogRef<UploadFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModelEventiCalamitosi.DialogData,
    public datePipe: DatePipe,
    private alertsCenterService: AlertsCenterService,
    private http: HttpClient) {
  }

  ngOnDestroy(): void {
    window.location.reload();
  }

  ngOnInit(): void {
    this.acl = sessionStorage.getItem("acl");
    this.nomeEvento = this.data.descrizione;
    this.idEvento = this.data.idEvento;
    this.idEnte = this.data.idEnte;
    this.idInvio = this.data.idInvio;
    this.validateNumProto(this.numProtoEnteAt);
  }

  ngAfterViewInit(): void {
    if (this.numProtoInput) {
      this.validateNumProto(this.numProtoEnteAt);
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.fileUploaded = input.files[0];
      this.fileName = this.fileUploaded.name;
      this.fileSize = this.formatFileSize(this.fileUploaded.size);
      this.fileType = this.fileUploaded.type || 'Unknown';
    }
  }

  // Funzione di validazione per il campo Numero Protocollo Ente Attuatore
  validateNumProto(value: string | null): void {
    const isOnlyNumeric = /^\d+$/.test(value || '');

    // Aggiorna la proprietà del componente (usata per disabilitare il bottone)
    if (value === null || value === '') {
      this.isNumProtoInvalid = false;
    } else {
      this.isNumProtoInvalid = !isOnlyNumeric;
    }

    if (this.numProtoInput?.control) {
        if (!isOnlyNumeric && (value !== null && value !== '')) {
            this.numProtoInput.control.setErrors({ 'nonNumeric': true, ...this.numProtoInput.control.errors });
        } else {
            const currentErrors = this.numProtoInput.control.errors;
            if (currentErrors && currentErrors['nonNumeric']) {
                delete currentErrors['nonNumeric'];
                this.numProtoInput.control.setErrors(Object.keys(currentErrors).length > 0 ? currentErrors : null);
            }
        }
    }
  }

  uploadFile(): void {
    // Aggiunge un controllo di blocco prima di procedere con l'upload
    if (!this.fileUploaded || this.isNumProtoInvalid || !this.numProtoEnteAt || !this.dataProtoEnteAt) {
      return;
    }

    this.isError = false;
    this.isUploading = true;
    this.uploadProgress = 0;

    //body post call
    const formData = new FormData();
    formData.append('file', this.fileUploaded);
    formData.append('fileName', String(this.fileName));
    formData.append('idEvento', String(this.idEvento));
    formData.append('idEnte', String(this.idEnte));
    formData.append('idInvio', String(this.idInvio));
    formData.append('numProtoEnteAt', String(this.numProtoEnteAt));
    formData.append('dataProtoEnteAt', String(this.dataProtoEnteAt));

    this.http.post(`${environment.urls.base}/files/upload`, formData, {
      reportProgress: true,
      observe: 'events'
    }).subscribe(event => {
      if (event.type === HttpEventType.UploadProgress) {
        this.uploadProgress = Math.round(100 * event.loaded / (event.total || 1));
      } else if (event.type === HttpEventType.Response) {
        console.log(event);
        this.alertsCenterService.showAlert({ type: 'success', message: "UPLOAD AVVENUTO CON SUCCESSO".toLocaleLowerCase(), autoClosable: true });
        this.isUploading = false;
        this.isError = false;
        this.uploadCompletedWithoutErrors = true;
      }
    }, error => {
      console.error(error);
      this.alertsCenterService.showAlert({ type: 'danger', message: "ERRORE UPLOAD DEL FILE, RIPROVARE".toLocaleLowerCase(), autoClosable: true });
      this.isUploading = false;
      this.isError = true;
    });
  }

  private formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }



}
